import { DataGridPro, gridClasses } from "@mui/x-data-grid-pro";
import { useCallback, useContext, useMemo, useState } from "react";
import { FilterC } from "../../filter/FilterComon";
import { Box, Collapse, LinearProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Context } from "./Context";
import RefreshIcon from "@mui/icons-material/Refresh";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
//import AddTaskIcon from '@mui/icons-material/AddTask';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AdjustIcon from "@mui/icons-material/Adjust";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
//import EditNoteIcon from "@mui/icons-material/EditNote";
import { ContextMenu } from "../../context_menu/ContextMenu";
import { getBorder } from "../../../utils/Styles";
import { Table as Audit } from "../audit/Table";
import { renderCell } from "./RenderCell";
import { useNavigate } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PunchClockIcon from "@mui/icons-material/PunchClock";
/* import SaveIcon from '@mui/icons-material/Save'; */
import GroupsIcon from "@mui/icons-material/Groups";
//import { MassiveApprove } from "../../dialog/overtime/MassiveApprove"
import moment from "moment";
import { Approve } from "../../dialog/overtime/Approve";
import { Reject } from "../../dialog/overtime/Reject";
import { Partial } from "../../dialog/overtime/Partial";
import { Recant } from "../../dialog/overtime/Recant";
// import { AddComment } from "../../dialog/overtime/AddComment";
import { GridColumnMenu } from "@mui/x-data-grid";
import { trackGaClick } from "../../../utils/analytics";

const CustomColumnMenu = (props) => {
	return (
		<>
			<GridColumnMenu
				{...props}
				slots={{
					// Hide `columnMenuColumnsItem`
					columnMenuColumnsItem: null,
				}}
			/>
		</>
	);
};

const Table = () => {
	const { t } = useTranslation("overtime.table");
	const navigate = useNavigate();

	const {
		apiRef,
		rows,
		range1,
		smartgroup,
		employee,
		periods,
		reloading,
		loadingGettingTimecard,
		loadingGettingSchedule,
		loadingGettingOpenPeriod,
	} = useContext(Context);

	const [checked, setChecked] = useState([]);
	const [contextMenu, setContextMenu] = useState(null);
	const [open, setOpen] = useState(false);

	const [openApprove, setOpenApprove] = useState(false);
	const [openPartial, setOpenPartial] = useState(false);
	const [openReject, setOpenReject] = useState(false);
	const [openRecant, setOpenRecant] = useState(false);
	// const [openAddComment, setOpenAddComment] = useState(false);
	// eslint-disable-next-line
	const [openRetract, setOpenRetract] = useState(false);

	//const [openMassive, setOpenMassive] = useState(false)

	const columns = useMemo(
		() => [
			{
				field: "full_name",
				headerName: t("table.columns.full_name"),
				minWidth: 240,
				flex: 2,
			},
			{
				field: "date",
				headerName: t("table.columns.date"),
				flex: 0.5,
				minWidth: 110,
				align: "center",
				valueFormatter: (params) => moment(params.value, "YYYY-MM-DD").format("DD/MM/YYYY"),
			},
			{
				field: "shifts",
				headerName: t("table.columns.shifts"),
				width: 190,
				minWidth: 190,
				filterable: false,
				renderCell,
			},
			{
				field: "punches",
				headerName: t("table.columns.punches"),
				width: 320,
				minWidth: 320,
				filterable: false,
				renderCell,
			},
			{
				field: "action",
				headerName: t("table.columns.action"),
				width: 220,
				minWidth: 220,
				filterable: false,
				renderCell,
			},
			{
				field: "parcial_amount",
				headerName: t("table.columns.parcial_amount"),
				width: 160,
				minWidth: 160,
				filterable: false,
				renderCell,
			},
			{
				field: "amount",
				headerName: t("table.columns.amount"),
				flex: 0.5,
				minWidth: 80,
				filterable: false,
				align: "center",
			},
			{
				field: "status",
				headerName: t("table.columns.status"),
				flex: 0.5,
				valueFormatter: (params) => t(`table.columns.${params.value}`),
			},
			{
				field: "comment",
				headerName: t("table.columns.comment"),
				width: 200,
				minWidth: 200,
				filterable: false,
				renderCell,
			},
			{
				field: "note",
				headerName: t("table.columns.note"),
				width: 150,
				minWidth: 150,
				filterable: false,
				renderCell,
			},
		],
		[t],
	);

	const options = useMemo(
		() => [
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges")).employees.show_page,
				name: t("table.menu.go_to_employees"),
				click: () => {
					sessionStorage.setItem(
						"employees",
						JSON.stringify({
							environment: JSON.parse(sessionStorage.getItem("employees"))?.environment
								? JSON.parse(sessionStorage.getItem("employees")).environment
								: null,
							redirect: {
								start: range1[0].format("YYYY-MM-DD"),
								end: range1[1].format("YYYY-MM-DD"),
								smartgroups: smartgroup
									.filter((sg) => employee.map((e) => e.smartgroup).includes(sg.name))
									.map((sg) => sg),
								employees: rows
									.filter((row) => checked.includes(row.id))
									.map((row) => ({
										id: row.person_number,
										full_name: row.full_name,
										smartgroup: row?.smartgroup,
									})),
							},
						}),
					);

					navigate("/employees");
				},
				icon: <GroupsIcon />,
				group: 1,
				disabled: checked.length < 1,
				seleted: true,
				onlyOne: false,
				dialog: undefined,
			},
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges")).schedule.show_page,
				name: t("table.menu.go_to_schedule"),
				click: () => {
					sessionStorage.setItem(
						"schedule",
						JSON.stringify({
							environment: JSON.parse(sessionStorage.getItem("schedule"))?.environment
								? JSON.parse(sessionStorage.getItem("schedule")).environment
								: null,
							redirect: {
								start: range1[0].format("YYYY-MM-DD"),
								end: range1[1].format("YYYY-MM-DD"),
								smartgroups: smartgroup
									.filter((sg) => employee.map((e) => e.smartgroup).includes(sg.name))
									.map((sg) => sg),
								employees: rows
									.filter((row) => checked.includes(row.id))
									.map((row) => ({
										id: row.person_number,
										full_name: row.full_name,
										smartgroup: row?.smartgroup,
									})),
							},
						}),
					);

					navigate("/schedule");
				},
				icon: <CalendarMonthIcon />,
				group: 1,
				disabled: checked.length < 1,
				seleted: true,
				onlyOne: false,
				dialog: undefined,
			},
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges")).timecard.show_page,
				name: t("table.menu.go_to_timecard"),
				click: () => {
					sessionStorage.setItem(
						"timecard",
						JSON.stringify({
							environment: JSON.parse(sessionStorage.getItem("timecard"))?.environment
								? JSON.parse(sessionStorage.getItem("timecard")).environment
								: null,
							redirect: {
								start: range1[0].format("YYYY-MM-DD"),
								end: range1[1].format("YYYY-MM-DD"),
								smartgroups: smartgroup
									.filter((sg) => employee.map((e) => e.smartgroup).includes(sg.name))
									.map((sg) => sg),
								employees: rows
									.filter((row) => checked.includes(row.id))
									.map((row) => ({
										id: row.person_number,
										full_name: row.full_name,
										smartgroup: row?.smartgroup,
									})),
							},
						}),
					);
					navigate("/timecard");
				},
				icon: <PunchClockIcon />,
				group: 1,
				disabled: checked.length < 1,
				seleted: true,
				onlyOne: false,
				dialog: undefined,
			},
			// {
			// 	privilege: JSON.parse(sessionStorage.getItem("privileges")).overtime.add_approve_overtime,
			// 	name: t("table.menu.add_comment_and_note"),
			// 	click: () => {
			// 		setOpenAddComment(true);
			// 		setContextMenu(null);
			// 	},
			// 	icon: <EditNoteIcon />,
			// 	group: 2,
			// 	disabled: checked.length < 1,
			// 	seleted: true,
			// 	onlyOne: false,
			// 	dialog: <AddComment open={openAddComment} setOpen={setOpenAddComment} data={rows} checked={checked} />,
			// },
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges")).overtime.add_approve_overtime,
				name: t("table.menu.full_approval"),
				click: () => {
					trackGaClick({
						id: "overtime.add_approve_overtime",
						gaAction: "approve_overtime",
						gaType: "full",
						extra: { checked },
					});
					//setContextMenu(null)
					let nrows = rows;

					for (const row of nrows.filter((row) => row.status === "pending")) {
						if (checked.includes(row.id)) {
							row.action = "all";
							row.partial_amount = row.amount;
						}
					}

					apiRef.current.setRows(nrows);

					setOpenApprove(true);
					setContextMenu(null);
				},
				icon: <CheckCircleOutlineIcon />,
				group: 2,
				disabled:
					rows.filter((row) => checked.includes(row.id)).filter((row) => row.status === "pending")
						.length === 0,
				seleted: true,
				onlyOne: false,
				dialog: <Approve open={openApprove} setOpen={setOpenApprove} data={rows} checked={checked} />,
			},
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges")).overtime.add_approve_overtime,
				name: t("table.menu.partial_approval"),
				click: () => {
					//setContextMenu(null)
					trackGaClick({
						id: "overtime.add_approve_overtime",
						gaAction: "approve_overtime",
						gaType: "partial",
						extra: { checked },
					});
					let nrows = rows;

					for (const row of nrows) {
						if (checked.includes(row.id) && row.status === "pending") {
							row.action = "some";
						}
					}

					apiRef.current.setRows(nrows);

					setOpenPartial(true);
					setContextMenu(null);
				},
				icon: <AdjustIcon />,
				group: 2,
				disabled:
					rows.filter((row) => checked.includes(row.id)).filter((row) => row.status === "pending")
						.length === 0,
				seleted: true,
				onlyOne: false,
				dialog: <Partial open={openPartial} setOpen={setOpenPartial} data={rows} checked={checked} />,
			},
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges")).overtime.add_approve_overtime,
				name: t("table.menu.reject_everything"),
				click: () => {
					//setContextMenu(null)
					trackGaClick({
						id: "overtime.add_approve_overtime",
						gaAction: "approve_overtime",
						gaType: "reject",
						extra: { checked },
					});
					let nrows = rows;

					for (const row of nrows) {
						if (checked.includes(row.id) && row.status === "pending") {
							row.action = "none";
							row.partial_amount = row.amount;
						}
					}

					apiRef.current.setRows(nrows);

					setOpenReject(true);
					setContextMenu(null);
				},
				icon: <HighlightOffIcon />,
				group: 2,
				disabled:
					rows.filter((row) => checked.includes(row.id)).filter((row) => row.status === "pending")
						.length === 0,
				seleted: true,
				onlyOne: false,
				dialog: <Reject open={openReject} setOpen={setOpenReject} data={rows} checked={checked} />,
			},
			{
				privilege: JSON.parse(sessionStorage.getItem("privileges")).overtime.remove_approve_overtime,
				name: t("table.menu.recant"),
				click: () => {
					trackGaClick({
						id: "overtime.remove_approve_overtime",
						gaAction: "remove_approve_overtime",
						gaType: "recant",
						extra: { checked },
					});
					setOpenRecant(true);
					setContextMenu(null);
				},
				icon: <PanoramaFishEyeIcon />,
				group: 2,
				disabled: false,
				seleted: true,
				onlyOne: false,
				dialog: <Recant open={openRecant} setOpen={setOpenRecant} data={rows} checked={checked} />,
			},
			{
				privilege: true,
				name: t(open ? "table.menu.close_audit" : "table.menu.open_audit"),
				click: () => {
					trackGaClick({
						id: "overtime.open_audit",
						gaAction: "open_audit",
						gaType: open ? "close" : "open",
					});
					setContextMenu(null);
					setOpen(!open);
				},
				icon: <PendingActionsIcon />,
				divider: JSON.parse(sessionStorage.getItem("privileges")).overtime.add_approve_overtime,
				group: 3,
				seleted: false,
				onlyOne: false,
				dialog: undefined,
			},
			{
				privilege: true,
				name: t("table.menu.reload"),
				click: () => {
					trackGaClick({
						id: "overtime.reload_table",
						gaAction: "reload",
						gaType: "manual",
					});
					setContextMenu(null);
					reloading();
				},
				icon: <RefreshIcon />,
				group: 4,
				disabled: JSON.parse(sessionStorage.getItem("overtime"))?.reloading ? false : true,
				seleted: false,
				onlyOne: false,
				dialog: undefined,
			},
		],
		[
			apiRef,
			checked,
			employee,
			navigate,
			open,
			// openAddComment,
			openApprove,
			openPartial,
			openRecant,
			openReject,
			range1,
			reloading,
			rows,
			smartgroup,
			t,
		],
	);

	return (
		<Box
			sx={{
				[`.${gridClasses.cell}.open`]: {
					backgroundColor: (theme) => theme.palette.background.default,
				},
				[`.${gridClasses.cell}.close`]: {
					backgroundColor: (theme) => theme.palette.background.close,
				},
			}}
		>
			<div
				onContextMenu={(event) => {
					event.preventDefault();

					if (openApprove) {
						return;
					}

					setContextMenu(
						contextMenu === null
							? {
									mouseX: event.clientX + 2,
									mouseY: event.clientY - 6,
							  }
							: null,
					);
				}}
			>
				<DataGridPro
					showCellVerticalBorder
					showColumnVerticalBorder
					//unstable_headerFilters
					checkboxSelection
					loading={loadingGettingTimecard || loadingGettingSchedule || loadingGettingOpenPeriod}
					columns={columns}
					rows={rows}
					slots={{
						toolbar: useCallback(() => <FilterC view={"overtime"} />, []),
						loadingOverlay: LinearProgress,
						columnMenu: CustomColumnMenu,
					}}
					rowSelectionModel={checked}
					onRowSelectionModelChange={(newRowSelectionModel) => {
						setChecked(newRowSelectionModel);
					}}
					sx={{
						height: `calc(100vh - ${open ? "55vh" : "120px"})`,
						border: (theme) => `1px solid ${theme.palette.divider}`,
					}}
					getRowHeight={(params) => {
						const { model } = params;

						let length = 84;

						for (const key in model) {
							let counter = 0;

							if (key === "punches") {
								counter = counter + model[key].length * 47;
							}

							if (counter > length) {
								length = counter;
							}
						}

						return length;
					}}
					getCellClassName={(params) => {
						if (!moment(params?.row?.date, "YYYY-MM-DD").isValid()) {
							return "";
						}

						const date1 = moment(
							periods.find((period) => period.person_number === params?.row?.person_number)?.end_date,
							"YYYY-MM-DD",
						);
						const date2 = moment(params?.row?.date, "YYYY-MM-DD");

						const style = date1.isSameOrAfter(date2);

						return style ? "close" : "open";
					}}
					isRowSelectable={(params) => {
						const date1 = moment(
							periods.find((period) => period.person_number === params?.row?.person_number)?.end_date,
							"YYYY-MM-DD",
						);
						const date2 = moment(params?.row?.date, "YYYY-MM-DD");

						return date1.isBefore(date2);
					}}
					apiRef={apiRef}
					hideFooter
					disableRowSelectionOnClick
				/>

				<ContextMenu
					contextMenu={contextMenu}
					setContextMenu={setContextMenu}
					options={options}
					checked={checked}
				/>
			</div>

			<Collapse
				sx={{
					height: "55vh",
					mt: 2.5,
					ml: -2.5,
					mr: -2.5,
					p: 2.5,
					borderTop: (theme) => getBorder(theme.palette.mode),
				}}
				in={open}
				timeout="auto"
				unmountOnExit
			>
				<Audit view={"overtime"} />
			</Collapse>
		</Box>
	);
};

export { Table };
